// @ts-nocheck
import React from 'react';
import { motion } from 'framer-motion';
import projectDeckImage from '../assets/projectdesk.png';
import websiteImage from '../assets/Group 4374.png';
import documentationImage from '../assets/Group 4377.png';
import grantImage from '../assets/Group 4378.png';
import fullServiceImage from '../assets/Group 4379.png';
import projectManagementImage from '../assets/Group 4380.png';
import testimonialImage from '../assets/Group 4365.png';
import waveImage from '../assets/blue-glossy-wave-on-black-background-2 1.png';

// Function to scroll to contact section in the footer
const scrollToContact = () => {
  const footerSection = document.getElementById('footer-section');
  if (footerSection) {
    footerSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const AdditionalServicesSection = () => {
  return (
    <section id="additional-services" className="section bg-background">
      <div className="container">
        {/* Project Deck Design */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12 md:mb-24">
          <div className="order-2 lg:order-1 hidden lg:flex justify-center">
            <motion.img 
              src={projectDeckImage}
              alt="Project Deck Design"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
          
          <div className="order-1 lg:order-2">
            <h3 className="text-2xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">PROJECT DECK DESIGN</h3>
            <p className="text-lg md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-white/80">
              Make a lasting impression with a professionally designed pitch deck. We craft compelling, investor-ready presentations with clear storytelling and engaging visuals. Includes up to 12 slides ($60 per additional slide).
            </p>
            <button className="btn bg-black text-white hover:bg-black/80 border border-white mt-4" onClick={scrollToContact}>
              Get Started
            </button>
          </div>
        </div>
        
        {/* Project Website Development */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12 md:mb-24">
          <div>
            <h3 className="text-2xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">PROJECT WEBSITE DEVELOPMENT</h3>
            <p className="text-lg md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-white/80">
              Your website is your digital storefront. We design modern, user-friendly, and responsive websites tailored to your brand's identity, ensuring a seamless user experience and strong digital presence in both traditional and Web3 ecosystems.
            </p>
            <button className="btn bg-black text-white hover:bg-black/80 border border-white mt-4" onClick={scrollToContact}>
              Get Started
            </button>
          </div>
          
          <div className="hidden lg:flex justify-center">
            <motion.img 
              src={websiteImage}
              alt="Website Development"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
        </div>
        
        {/* Whitepaper and Project Documentation */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12 md:mb-24">
          <div className="order-2 lg:order-1 hidden lg:flex justify-center">
            <motion.img 
              src={documentationImage}
              alt="Whitepaper and Documentation"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
          
          <div className="order-1 lg:order-2">
            <h3 className="text-2xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">WHITEPAPER & PROJECT DOCUMENTATION</h3>
            <p className="text-lg md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-white/80">
              Clear, professional documentation is crucial for Web3 projects. We create compelling whitepapers, technical documentation, and project materials that explain your vision, tokenomics, and technical architecture, helping you build trust with your audience.
            </p>
            <button className="btn bg-black text-white hover:bg-black/80 border border-white mt-4" onClick={scrollToContact}>
              Get Started
            </button>
          </div>
        </div>
        
        {/* Grant Application Assistance */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12 md:mb-24">
          <div>
            <h3 className="text-2xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">GRANT APPLICATION ASSISTANCE</h3>
            <p className="text-lg md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-white/80">
              We help you craft compelling grant applications, from structuring proposals to refining your pitch. Pricing depends on the level of support required.
            </p>
            <button className="btn bg-black text-white hover:bg-black/80 border border-white mt-4" onClick={scrollToContact}>
              Get Started
            </button>
          </div>
          
          <div className="hidden lg:flex justify-center">
            <motion.img 
              src={grantImage}
              alt="Grant Application Assistance"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
        </div>
        
        {/* Full-Service Startup Packages */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12 md:mb-24">
          <div className="order-2 lg:order-1 hidden lg:flex justify-center">
            <motion.img 
              src={fullServiceImage}
              alt="Full-Service Startup Packages"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
          
          <div className="order-1 lg:order-2">
            <h3 className="text-2xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">FULL-SERVICE STARTUP PACKAGES</h3>
            <p className="text-lg md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-white/80">
              For businesses looking for an all-in-one solution, our Full-Service Package includes:
              <br />- Fund opportunity research
              <br />- Project deck design
              <br />- Website design + go-live support
              <br />- Project documentation
              <br />- Grant application support
              <br />- Full project management
            </p>
            <button className="btn bg-black text-white hover:bg-black/80 border border-white mt-8" onClick={scrollToContact}>
              Get Started
            </button>
          </div>
        </div>
        
        {/* Project Management Services */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12 md:mb-24">
          <div>
            <h3 className="text-2xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">PROJECT MANAGEMENT SERVICES</h3>
            <p className="text-lg md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-white/80">
              Streamline your operations with expert project management. We oversee planning, execution, and reporting to keep your project on track.
            </p>
            <button className="btn bg-black text-white hover:bg-black/80 border border-white mt-4" onClick={scrollToContact}>
              Get Started
            </button>
          </div>
          
          <div className="hidden lg:flex justify-center">
            <motion.img 
              src={projectManagementImage}
              alt="Project Management Services"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
        </div>

        {/* Projects Section */}
        <div id="projects" className="flex justify-center mb-8 md:mb-16">
          <h2 className="text-xl md:text-2xl font-montserrat font-medium leading-tight tracking-normal text-center text-[#6D6D6D]">
            PROJECTS
          </h2>
        </div>
        
        {/* Projects Description */}
        <div className="flex justify-center mb-12 md:mb-24">
          <p className="text-2xl md:text-4xl lg:text-5xl font-montserrat font-medium leading-tight md:leading-snug tracking-normal text-center text-white max-w-5xl">
            We have provided the best services to various startups based on our significant industry experience.
          </p>
        </div>
        
        {/* Testimonial - LudoGate */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-12 md:mb-24">
          <div>
            <h3 className="text-xl md:text-2xl lg:text-3xl font-montserrat font-semibold leading-tight tracking-normal text-[#6D6D6D] mb-4">
              LUDOGATE
            </h3>
            <h4 className="text-lg md:text-xl lg:text-2xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">
              START UP SUPPORT
            </h4>
            <p className="text-base md:text-lg lg:text-xl font-montserrat font-normal leading-relaxed tracking-normal text-white/80 mb-4">
              Link Bridge did a professional job supporting our initial startup. With my busy schedule it was hard to put things together at the beginning of starting the project. They came in and supported me like an extension of my team
            </p>
            <p className="text-base md:text-lg lg:text-xl font-montserrat font-medium leading-relaxed tracking-normal text-[#6D6D6D]">
              - Mo.X<br />
              CEO LudoGate
            </p>
          </div>

          <div className="hidden lg:block">
            <motion.img 
              src={testimonialImage}
              alt="LudoGate Testimonial"
              className="w-full max-w-[380px] h-auto object-contain"
              animate={{
                y: [0, -10, 0],
                scale: [1, 1.02, 1],
                rotate: [0, 1, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
        </div>
        
        {/* Testimonial - MyKidsExcel */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-12 md:mb-24">
          <div>
            <h3 className="text-xl md:text-2xl lg:text-3xl font-montserrat font-semibold leading-tight tracking-normal text-[#6D6D6D] mb-4">
              MYKIDSEXCEL
            </h3>
            <h4 className="text-lg md:text-xl lg:text-2xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">
              GOAL ACHIEVEMENT
            </h4>
            <p className="text-base md:text-lg lg:text-xl font-montserrat font-normal leading-relaxed tracking-normal text-white/80 mb-4">
              Link Bridge has been very helpful to us. At the beginning we were short handed and needed support. They gave us support in reaching our goal. Very professional and skilled team
            </p>
            <p className="text-base md:text-lg lg:text-xl font-montserrat font-medium leading-relaxed tracking-normal text-[#6D6D6D]">
              - Fanny B<br />
              MyKidsExcel
            </p>
          </div>
          
          <div className="hidden lg:block">
            {/* Right side content removed */}
          </div>
        </div>
        
        {/* Testimonial - TON GYM */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-12 md:mb-24">
          <div>
            <h3 className="text-xl md:text-2xl lg:text-3xl font-montserrat font-semibold leading-tight tracking-normal text-[#6D6D6D] mb-4">
              TON GYM
            </h3>
            <h4 className="text-lg md:text-xl lg:text-2xl font-montserrat font-medium leading-tight tracking-normal text-white mb-6">
              INVESTOR PITCH & DESIGN DECK
            </h4>
            <p className="text-base md:text-lg lg:text-xl font-montserrat font-normal leading-relaxed tracking-normal text-white/80 mb-4">
              Link Bridge helped get our documents ready to speak to investors. We were so happy with the designs and we still use the style guide they provided till this date
            </p>
            <p className="text-base md:text-lg lg:text-xl font-montserrat font-medium leading-relaxed tracking-normal text-[#6D6D6D]">
              - Esther B.<br />
              TONGYM
            </p>
          </div>
          
          <div className="hidden lg:block">
            {/* Right side content removed */}
          </div>
        </div>

        {/* Wave Shape Section */}
        <div className="relative w-full overflow-hidden">
          <img 
            src={waveImage}
            alt="Wave Shape"
            className="w-full max-w-[1484px] mx-auto h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default AdditionalServicesSection;